import React from 'react';
import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';
import IconSvg from '@/components/common/IconSvg';
import { HeaderRowSchema } from './HeaderRow.styles';

export const TextDescription: CSSObject = {
  textTransform: 'capitalize',
};

export const RunnerDetails: CSSObject = {
  color: 'alpha.300',
};

export const RunnerDescription: CSSObject = {
  color: 'gray.400',
  fontWeight: 'bold',
};

export const BetOdds: CSSObject = {
  color: 'gray.700',
};

export const TextBarrierNumber: CSSObject = {
  color: 'alpha.300',
};

export const BetReturn = (status: TBetReturn): CSSObject => ({
  fontSize: '10px',
  color: () => {
    switch (status) {
      case 'won':
        return 'gamma.500';
      case 'lost':
        return 'alpha.200';
      case 'voided':
        return 'alpha.200';
      case 'cancelled':
        return 'white';
      case 'pending':
        return 'white';
      default:
    }
  },
  bg: () => {
    switch (status) {
      case 'won':
        return 'beta.600';
      case 'lost':
        return 'alpha.700';
      case 'voided':
        return 'alpha.700';
      case 'cancelled':
        return 'gray.400';
      case 'pending':
        return 'beta.500';
      default:
    }
  },
});

export const HeaderSvg: CSSObject = {
  color: 'alpha.300',
  boxSize: '5',
};

export const BetMultiIcon: CSSObject = {
  boxSize: '5',
  color: 'alpha.600',
};

export const MultiIcon = () => (
  <IconSvg
    name="MultiIconVolcanobet"
    className="svgIcon"
    boxSize="6"
    mb="1.5"
  />
);

export const headerRowStyles: HeaderRowSchema = {
  headerRowSvg: {
    fill: 'white',
  },
};
